import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query CustomerFile($uuid: ID!) {
    customerFile(uuid: $uuid) {
      downloadUrl
      file {
        status
        uuid
      }
    }
  }
`

export const customerFileKey = getQueryNames(query)[0]

export default query
